import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo, useState } from 'react';
import { getTransferrableProps } from '../../../utils/getTransferrableProps';
import { useProperty } from '../../../v2/hooks/useProperty';
import { usePropertyValue } from '../../../v2/hooks/usePropertyValue';
import { usePropertyValueFormatting } from '../../../v2/hooks/usePropertyValueFormatting';
import PropertyFormattedTooltip from '../../PropertyFormattedTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextAreaPopover = props => {
  const {
    inputRef,
    onChange,
    onBlur,
    popoverProps,
    placeholder
  } = props;
  const [showPopover, setShowPopover] = useState(true);
  const property = useProperty();
  const value = usePropertyValue();
  const displayedValue = value || placeholder;
  const {
    onChange: normalizeInputOnChange,
    onBlur: normalizeInputOnBlur,
    onKeyDown: normalizeInputOnKeyDown,
    normalizationRules
  } = usePropertyValueFormatting({
    onChange,
    onBlur
  });
  const popoverContent = useMemo(() => {
    const handleChange = event => {
      const newValue = event.target.value;
      return normalizeInputOnChange(Object.assign({}, event, {
        target: Object.assign({}, event.target, {
          value: newValue
        })
      }));
    };
    return /*#__PURE__*/_jsx(PropertyFormattedTooltip, {
      normalizationRules: normalizationRules,
      children: /*#__PURE__*/_jsx(TextArea, Object.assign({}, getTransferrableProps(props, ['disableFocusStyles']), {
        value: value === null ? '' : value,
        inputRef: inputRef,
        onChange: handleChange,
        onBlur: normalizeInputOnBlur,
        onKeyDown: normalizeInputOnKeyDown,
        styled: true,
        rows: 6,
        marginBlockEnd: "600"
      }))
    });
  }, [props, value, inputRef, normalizationRules, normalizeInputOnChange, normalizeInputOnBlur, normalizeInputOnKeyDown]);
  const handleOpenChange = useCallback(evt => {
    setShowPopover(evt.target.value);
  }, []);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  return /*#__PURE__*/_jsx(Popover, Object.assign({
    inlineSize: "400px",
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    content: {
      body: popoverContent,
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputTextArea.header",
          options: {
            label: property.label
          }
        })
      })
    },
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    "data-test-id": "property-input-text-area-popover",
    children: /*#__PURE__*/_jsx(Clickable, {
      onClick: handleClick,
      "data-test-id": "property-input-text-area-preview",
      alignItems: "center",
      blockSize: "100%",
      inlineSize: "100%",
      justifyContent: "center",
      display: "flex",
      children: /*#__PURE__*/_jsx(TruncateString, {
        tooltip: !showPopover,
        children: displayedValue
      })
    })
  }));
};
export default TextAreaPopover;